export default __webpack_public_path__ + "static/media/logo-scooter.c96eb120.svg";